/**
 * El seguimiento de una campaña (28/10/2026): lo que comparten la pantalla «Hacer un seguimiento», el detalle (el renglón
 * de la original y el de la hija) y el paso Audiencia del asistente de la hija. La regla de quién entra es del backend
 * (`util/seguimiento.util`): acá sólo los textos y las rutas.
 */

import type { CriterioSeguimiento, MotivoExclusion, OpcionesDeSeguimiento } from "../types";
import { ORDEN_GATES } from "../types";
import { MOTIVO_EXCLUSION, textoYaRecibio } from "./textos";

const B = "/activa/oficial/campanas";
const e = encodeURIComponent;

/** La pantalla para elegir el criterio (una página, no una ventana encima). */
export const rutaHacerSeguimiento = (id: string) => `${B}/${e(id)}/hacer-seguimiento`;
/** La hija recién armada se abre en el asistente, en «Qué les decís»: lo demás viene de la original y se revisa paso a paso. */
export const rutaAsistenteDeLaHija = (id: string) => `${B}/${e(id)}/editar?paso=mensaje`;
export const rutaCampana = (id: string) => `${B}/${e(id)}`;

export const TITULO_CRITERIO: Record<CriterioSeguimiento, string> = {
  no_leyeron: "No la leyeron",
  no_tocaron: "No tocaron el link",
  no_compraron: "No compraron",
};

export const DETALLE_CRITERIO: Record<CriterioSeguimiento, string> = {
  no_leyeron:
    "Les llegó y no hay lectura. La lectura sólo se ve si la persona tiene prendidas las confirmaciones de lectura: quien las tiene apagadas también entra.",
  no_tocaron: "Les llegó y no tocaron el botón con el link de la campaña.",
  no_compraron: "Están en tu base de ventas y no compraron en los días que elijas, contados desde que les llegó.",
};

/** El desglose de los que no entran, en palabras: lo que la pantalla muestra debajo de «Hoy quedan…». */
export function desgloseSeguimiento(el: NonNullable<OpcionesDeSeguimiento["elegido"]>, criterio: CriterioSeguimiento, sinBase: boolean): string[] {
  const n = (x: number) => x.toLocaleString("es-AR");
  const out: string[] = [];
  if (el.fuera.bajas) out.push(`${n(el.fuera.bajas)} se ${el.fuera.bajas === 1 ? "dio" : "dieron"} de baja con esta campaña`);
  if (el.fuera.respondieron) out.push(`${n(el.fuera.respondieron)} ${el.fuera.respondieron === 1 ? "respondió" : "respondieron"}`);
  if (criterio === "no_compraron" && el.fueraDeLaBase && !sinBase) {
    out.push(`${n(el.fueraDeLaBase)} no ${el.fueraDeLaBase === 1 ? "está" : "están"} en la base de ventas (no se sabe si compraron)`);
  }
  if (el.noEstan) out.push(`${n(el.noEstan)} ya no ${el.noEstan === 1 ? "está" : "están"} en la audiencia de la campaña`);
  for (const m of ORDEN_GATES as MotivoExclusion[]) {
    const x = Number(el.excluidos[m]) || 0;
    if (!x) continue;
    out.push(m === "fatiga" ? `${n(x)} ${textoYaRecibio(x, el.fatigaDias, el.fatigaMaximo ?? 1)}` : `${n(x)}: ${MOTIVO_EXCLUSION[m].titulo.toLowerCase()}`);
  }
  return out;
}
